import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    formFields: {
      display: 'flex',
      flex: '1 1 100%',
      flexFlow: 'column',
      overflowY: 'auto',
      padding: theme.spacing(3, 0, 0, 3),
      position: 'relative',
      width: '100%',
      color: theme.palette.text.primary,
      '& > *': {
        animation: '$fadeIn',
        animationDuration: '0.35s',
      },
      '& .ace_editor': {
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
      },
      '& > p': {
        alignItems: 'center',
        display: 'flex',
        color: theme.palette.coolGrey[400],
        fontWeight: 400,
        height: '100%',
        justifyContent: 'center',
        margin: theme.spacing(0, 3, 3, 0),
      },
      '& > svg': {
        height: 84,
        padding: theme.spacing(0, 3, 3, 0),
        width: 84,
      },
    },
  })
);

interface Props {
  children: JSX.Element | JSX.Element[];
}

const EntityDrawerContent = ({ children }: Props) => {
  const classes = useStyles();
  return <div className={classes.formFields}>{children}</div>;
};

export default EntityDrawerContent;
